import React from 'react';
import './ImageOverlay.css'

export const ImageOverlay = ({ toggleMediaVault, isCroppable, toggleCroppie, isEditing = false, toggleTextEdit = null }) => {
    return (<div className="image-overlay">
        <span href="#" className="image-icon" title="image">
            <i
                onClick={toggleMediaVault}
                style={{ cursor: 'pointer' }}
                className="fa fa-image"></i>
            {isCroppable ? <i
                onClick={toggleCroppie}
                style={{ cursor: 'pointer', marginLeft: 10 }}
                className="fa fa-crop"></i> : null}
            {isEditing ? <i
                onClick={toggleTextEdit}
                style={{ cursor: 'pointer', marginLeft: 10 }}
                className="fa fa-edit"></i> : null}
        </span>
    </div>)
}